import { render, staticRenderFns } from "./sdwan_page.vue?vue&type=template&id=68c75457"
import script from "./sdwan_page.vue?vue&type=script&lang=js"
export * from "./sdwan_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports